import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';


const Page404 = () => {
    const {t} = useTranslation();

    return (
        <Typography
            variant="h4"
            sx={{pt: '6rem', textAlign: 'center'}}
            color="text.secondary"
        >
            {t('page_not_found')}
        </Typography>
    )
};

export default Page404;
